// Messages for operator/settings/Metafields (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.metafields.head': 'Metafields — Operator',
  'operator.metafields.title': 'Custom fields',
  'operator.metafields.desc': 'Typed metafields attached to core records.',
  'operator.metafields.new_field': 'New field',
  'operator.metafields.create': 'Create field',
  'operator.metafields.cancel': 'Cancel',
  'operator.metafields.apply_hint':
    'Define a field here, then set its value from a shipment, customer or carrier detail page (the “Custom fields” card). Portal-visible fields also appear in the customer portal + API.',
  'operator.metafields.field_label': 'Label (optional)',
  'operator.metafields.label_placeholder': 'e.g. Incoterm note',
  'operator.metafields.required_badge': 'required',
  'operator.metafields.applies_to': 'Applies to',
  'operator.metafields.namespace': 'Namespace',
  'operator.metafields.key': 'Key',
  'operator.metafields.key_error': 'Key {error}',
  'operator.metafields.type': 'Type',
  'operator.metafields.value_type_aria': 'Value type',
  'operator.metafields.portal_visible': 'Portal-visible',
  'operator.metafields.required': 'Required',
  'operator.metafields.options_label': 'Options (comma-separated)',
  'operator.metafields.add': 'Add field',
  'operator.metafields.col.model': 'Model',
  'operator.metafields.col.field': 'Field',
  'operator.metafields.col.type': 'Type',
  'operator.metafields.col.portal': 'Portal',
  'operator.metafields.visible': 'visible',
  'operator.metafields.internal': 'internal',
  'operator.metafields.delete': 'Delete',
  'operator.metafields.empty': 'No custom fields defined yet.',
}

export const zhTW = {
  'operator.metafields.head': '自訂欄位 — 操作員',
  'operator.metafields.title': '自訂欄位',
  'operator.metafields.desc': '附加於核心紀錄的型別化自訂欄位。',
  'operator.metafields.new_field': '新增欄位',
  'operator.metafields.create': '建立欄位',
  'operator.metafields.cancel': '取消',
  'operator.metafields.apply_hint':
    '在此定義欄位，然後於貨件、客戶或承運商的詳細頁面（「自訂欄位」卡片）設定其值。入口可見的欄位也會出現在客戶入口網站與 API。',
  'operator.metafields.field_label': '標籤（選填）',
  'operator.metafields.label_placeholder': '例如：貿易條件備註',
  'operator.metafields.required_badge': '必填',
  'operator.metafields.applies_to': '套用於',
  'operator.metafields.namespace': '命名空間',
  'operator.metafields.key': '鍵',
  'operator.metafields.key_error': '鍵{error}',
  'operator.metafields.type': '類型',
  'operator.metafields.value_type_aria': '值類型',
  'operator.metafields.portal_visible': '入口可見',
  'operator.metafields.required': '必填',
  'operator.metafields.options_label': '選項（以逗號分隔）',
  'operator.metafields.add': '新增欄位',
  'operator.metafields.col.model': '模型',
  'operator.metafields.col.field': '欄位',
  'operator.metafields.col.type': '類型',
  'operator.metafields.col.portal': '入口',
  'operator.metafields.visible': '可見',
  'operator.metafields.internal': '內部',
  'operator.metafields.delete': '刪除',
  'operator.metafields.empty': '尚未定義自訂欄位。',
}
